
export const CPANEL = 'cpanel';
export const TITAN = 'proemail';
